import { Navigate, useRoutes } from 'react-router-dom';
import { lazy } from 'react';
import { useAppSelector } from '../redux/hooks';

const Login = lazy(() => import('../views/login/Login'));
// const Dashboard = lazy(() => import('../views/dashboard/Dashboard'));
const DeviceChannelsConfiguration = lazy(
	() => import('../views/devices/DeviceChannelsConfiguration')
);
const EnergyConsumption = lazy(() => import('../views/energy-consumption/EnergyConsumption'));
const WeeklyReport = lazy(() => import('../views/weekly-report/WeeklyReport'));
const MonthlyReport = lazy(() => import('../views/monthly-report/MonthlyReport'));

function AppRoutes() {
	const loggedIn = useAppSelector((state) => state.authentication.loggedIn);

	return useRoutes([
		{
			path: '/login',
			element: loggedIn ? <Navigate replace to="/energy-consumption" /> : <Login />,
		},
		// Will be added back the next version
		// {
		// 	path: '/dashboard',
		// 	element: loggedIn ? <Dashboard /> : <Navigate replace to="/login" />,
		// },
		{
			path: '/energy-consumption',
			element: loggedIn ? <EnergyConsumption /> : <Navigate replace to="/login" />,
		},
		{
			path: '/device-channels-configuration',
			element: loggedIn ? <DeviceChannelsConfiguration /> : <Navigate replace to="/login" />,
		},
		{
			path: '/weekly-report',
			element: loggedIn ? <WeeklyReport /> : <Navigate replace to="/login" />,
		},
		{
			path: '/monthly-report',
			element: loggedIn ? <MonthlyReport /> : <Navigate replace to="/login" />,
		},
		{ path: '*', element: <Navigate to="/energy-consumption" replace /> },
	]);
}

export default AppRoutes;
